import React from "react";
import { Collapse } from "@mui/material";
import styles from "./EditReqDialog.module.css";
import { translate, translateEnumParam } from "../../../../../common/providers";
import { CustomIconButton, icon, Selector } from "../../../../../common/components";

export default function ParamsSection({ params, collapsed, selectedParams, onChangeParams, onCollaspe }) {
	return (
		<section className={styles["dialog-content__section"]}>
			<span className={styles["dialog-content__section-title"]}>
				<CustomIconButton icon={collapsed ? icon.faChevronDown : icon.faChevronRight} onClick={onCollaspe} />
				{translate("requirement-matrix.param-section.parameters")}
			</span>
			<Collapse unmountOnExit in={collapsed} timeout="auto">
				<div className={styles["dialog-content__section-params"]}>
					{params &&
						Object.keys(params).map((param) => {
							const getLabel = (itemValue) => translateEnumParam(param, itemValue);
							return (
								<Selector
									key={param}
									fullWidth
									withNone
									autoTranslate="no"
									className={styles["dialog-content__section-param"]}
									itemRenderer={getLabel}
									items={params[param]}
									label={translateEnumParam(param)}
									size="sm"
									value={(selectedParams && selectedParams[param]) || ""}
									valueRenderer={getLabel}
									onChange={(e) => onChangeParams(param, e.target.value)}
								/>
							);
						})}
				</div>
			</Collapse>
		</section>
	);
}
